import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=56f57d44&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=js"
export * from "./Manager.vue?vue&type=script&lang=js"
import style0 from "./Manager.vue?vue&type=style&index=0&id=56f57d44&prod&lang=css"
import style1 from "./Manager.vue?vue&type=style&index=1&id=56f57d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f57d44",
  null
  
)

export default component.exports